import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["videoId", "onVideoReady", "playerType", "thumbnail", "aspectRatio"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { IMAGE_DECODING, IMAGE_FETCHPRIORITY, IMAGE_LOADING } from "../../constants/image";
import { memo, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Script from 'next/script';
import { WISTIA_SCRIPT_URL, PLAYER_TYPES } from "./constants";
import { EMBED_OPTIONS } from "./utils";
import { WistiaContainer, WistiaThumbnailImage, Wrapper } from "./wistia-player.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var WistiaPlayer = function WistiaPlayer(props) {
  var videoRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isVideoReady = _useState2[0],
    setIsVideoReady = _useState2[1];
  var videoId = props.videoId,
    onVideoReady = props.onVideoReady,
    playerType = props.playerType,
    thumbnail = props.thumbnail,
    aspectRatio = props.aspectRatio,
    customEmbedOptions = _objectWithoutProperties(props, _excluded);
  useEffect(function () {
    if (videoRef.current && window._wq) {
      videoRef.current.replaceWith(videoId);
      return;
    }
    window.wistiaDisableMux = true;
    window._wq = window._wq || [];
    var embedOptionsByType = EMBED_OPTIONS[playerType] || EMBED_OPTIONS[PLAYER_TYPES.DEFAULT_FROM_WISTIA];
    window._wq.push({
      id: videoId,
      options: _objectSpread(_objectSpread({}, embedOptionsByType), customEmbedOptions),
      onReady: function onReady(video) {
        videoRef.current = video;
        setIsVideoReady(true);
        onVideoReady === null || onVideoReady === void 0 ? void 0 : onVideoReady(video);
      }
    });
  }, [customEmbedOptions, onVideoReady, playerType, videoId]);
  return /*#__PURE__*/_jsxs(WistiaContainer, {
    aspectRatio: aspectRatio,
    children: [!isVideoReady && thumbnail && /*#__PURE__*/_jsx(WistiaThumbnailImage, {
      src: thumbnail,
      loading: IMAGE_LOADING.lazy,
      decoding: IMAGE_DECODING.async,
      fetchpriority: IMAGE_FETCHPRIORITY.low,
      role: "presentation"
    }), /*#__PURE__*/_jsx(Script, {
      "data-testid": "wistia-player",
      src: WISTIA_SCRIPT_URL,
      strategy: "lazyOnload"
    }), playerType !== PLAYER_TYPES.VIDEO_BACKGROUND ? /*#__PURE__*/_jsx(Wrapper, {
      className: "wistia_responsive_padding",
      "data-testid": "wrapper-default",
      aspectRatio: aspectRatio,
      children: /*#__PURE__*/_jsx("div", {
        className: "wistia_embed wistia_async_".concat(videoId, " googleAnalytics=false"),
        style: {
          height: '100%',
          position: 'relative',
          width: '100%'
        },
        children: "\xA0"
      })
    }) : /*#__PURE__*/_jsx(Wrapper, {
      className: "wistia_embed wistia_async_".concat(videoId, " googleAnalytics=false"),
      "data-testid": "wrapper-video-background",
      disableInteraction: true,
      children: "\xA0"
    })]
  });
};
WistiaPlayer.propTypes = {
  videoId: PropTypes.string.isRequired,
  onVideoReady: PropTypes.func,
  playerType: PropTypes.string,
  thumbnail: PropTypes.string,
  aspectRatio: PropTypes.string
};
WistiaPlayer.defaultProps = {
  onVideoReady: null,
  playerType: PLAYER_TYPES.DEFAULT_FROM_WISTIA,
  thumbnail: '',
  aspectRatio: ''
};
WistiaPlayer.displayName = 'WistiaPlayer';
export default /*#__PURE__*/memo(WistiaPlayer);